export default __webpack_public_path__ + "assets/ghost2.29a48e.svg";